import { Row, Col, Form, Select, Button } from "antd";
import { HeaderUser } from "../../components/HeaderUser";
import { FormattedMessage } from "react-intl";
import { useEffect, useState } from "react";
import { useIndexedDBStore } from "use-indexeddb";
import { CollapseComponent } from "../../components/Collapse";
import { Option } from "antd/lib/mentions";
import cookie from "react-cookies";
import {
  getListTemplatesUser,
  toAddUpdateSettings,
  toGetSettingsUser,
} from "../../utils/APIs";
import { getTranslatedValue, successMsg } from "../../utils/Utils";

const General = ({ SettingStore }) => {
  const [form] = Form.useForm();
  const { deleteAll, getAll, add } = useIndexedDBStore("templates");
  const db = useIndexedDBStore("settingsUser");

  const [templateId, setTemplateId] = useState(-1);
  const [list, setList] = useState([]);
  useEffect(() => {
    var l = [];
    db.getAll().then((res) => {
      if (res.length > 0) {
        setTemplateId(res[0].templateId);
      }
    });
    getListTemplatesUser()
      .then((res) => {
        toGetData(res);
      })
      .catch((e) => {
        getAll().then((res) => {
          toGetData(res);
        });
      });
  }, []);

  const toGetData = (l) => {
    setList(l);
    toGetSettingsUser().then((res) => {
      if (null != res && null != res.templateId) {
        db.deleteAll().then(() => {
          db.add(res);
        });
        var element = l.filter((el) => el.id == res.templateId);
        if (element.length > 0) {
          form.setFieldsValue({
            select: element[0].name,
          });
        }
      }
    });
  };

  const save = () => {
    toAddUpdateSettings(templateId).then((res) => {
      db.deleteAll().then(() => {
        db.add({ templateId: templateId });
      });
      SettingStore.setTemplateId(templateId);

      successMsg(getTranslatedValue("infoSaved"));
    });
  };

  return (
    <>
      <HeaderUser />
      <div style={{ marginTop: "2vh" }}>
        <Row>
          <Col
            span={24}
            className="roi--settings-title"
            style={{ marginTop: "1.5vh", textAlign: "center" }}
          >
            <span style={{ marginLeft: "1vh" }}>
              <FormattedMessage id="general" />
            </span>
          </Col>
        </Row>
      </div>

      <CollapseComponent
        style={{ marginBottom: "2vh", marginTop: "2vh" }}
        headerText={
          <span>
            <FormattedMessage id="general" />
          </span>
        }
        classNameHeader="roi--collapse-header-green"
        content={
          <Row>
            <Col span="16">
              <h2 className="roi--label-section roi--line-after">
                <FormattedMessage id="defaultFormTab" />
              </h2>
            </Col>
            <Col span="2" />
            <Col span="5">
              <Form form={form}>
                <Form.Item name="select">
                  <Select
                    style={{ width: "100%" }}
                    onChange={(e) =>
                      setTemplateId(list.filter((el) => el.name == e)[0].id)
                    }
                    showSearch
                  >
                    {list.map((e) => (
                      <Option value={e.name}> {e.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        }
      ></CollapseComponent>
      <div style={{ textAlign: "center" }}>
        <Button
          className="roi--button-primary"
          htmlType="submit"
          style={{
            marginTop: "4vh",
            textAlign: "center",
            marginBottom: "2vh",
          }}
          onClick={() => save()}
        >
          <FormattedMessage id="validate" />
        </Button>
      </div>
    </>
  );
};
export default General;
